import { getBaseColumns, getPacsSpecificColumns, applyReferenceLayout } from "../../utils/sharedTableColumns";

export const orderColumns = ({
  openViewer,
  showOrdDetails,
  openRadDesk,
  openReportEditor,
  role,
  addFile,
  viewNotes,
  printReport,
  downloadDocxReport,
  viewReport,
  editSignedOffReport,
  assignToSelfTechnician,
  toggleReporting,
  toggleConfirmation,
  toggleFeatures,
  markMlc,
  handleShareStudy,
  handleDownloadStudy,
  handleExportStudy,
  editStudyDetails,
  showStudyHistory,
  handleSelectSeries,
  splitStudy,
  handleRadiologistAssignment,
  userList,
  openRadiantViewer,
  enableRadiantViewer,
  deleteOrder,
  canDeleteOrder
}) => {
  const baseColumns = getBaseColumns();
  const pacsSpecificColumns = getPacsSpecificColumns();

  // Customize patient name column to include openReportEditor and Radiant Viewer.
  // For technicians (T009) the patient-name click opens the viewer instead of the
  // report editor — they don't report, so viewing images is the useful action.
  const patientNameColumn = baseColumns.find(col => col.key === 'pat_name');
  if (patientNameColumn) {
    const originalRender = patientNameColumn.render;
    const nameClickHandler = role === 'technician' ? openViewer : openReportEditor;
    patientNameColumn.render = (text, record) => originalRender(text, record, nameClickHandler, openViewer, openRadiantViewer, enableRadiantViewer);
  }

  // Customize technician assignment column
  const techAssignColumn = pacsSpecificColumns.find(col => col.key === 'assigned_to_tech');
  if (techAssignColumn) {
    const originalRender = techAssignColumn.render;
    techAssignColumn.render = (text, record, ind) => originalRender(text, record, ind, assignToSelfTechnician);
  }

  // Customize radiologist assignment column
  const radAssignColumn = pacsSpecificColumns.find(col => col.key === 'assigned_radiologist');
  if (radAssignColumn) {
    const originalRender = radAssignColumn.render;
    radAssignColumn.render = (text, record, ind) => originalRender(text, record, ind, handleRadiologistAssignment, userList);
  }

  // Reference RIS-style flex layout for ALL roles. The action icons no longer
  // live in a trailing Actions column — they're rendered as leading (left-pinned)
  // columns by the page (see buildLeadingActionColumns), mirroring the reference.
  // Data columns are flex-weighted so the table fills the viewport with no
  // horizontal scroll. Role-specific columns (Reported/Signed By, Assigned
  // Technician/Radiologist) carry their own `hidden` flags and are filtered here.
  return applyReferenceLayout([...baseColumns, ...pacsSpecificColumns]);
};
